module.exports = __webpack_public_path__ + "img/American Credit_logo_TM_a.a5dc2ec.png";